import React from 'react'
import classNames from 'classnames/bind'
import styles from './Badge.module.scss'

const cx = classNames.bind(styles)

export type BadgeVariant = 'primary' | 'success' | 'danger' | 'warning' | 'info' | 'purple' | 'muted'

interface BadgeProps {
  variant?: BadgeVariant
  dot?: boolean
  className?: string
  children: React.ReactNode
}

export default function Badge({ variant = 'muted', dot = false, className, children }: BadgeProps) {
  return (
    <span className={cx('badge', `badge--${variant}`, { 'badge--dot': dot }, className)}>
      {children}
    </span>
  )
}
